import DOMPurify from "dompurify";
import type { TocItem } from "../types";

export interface PreparedContent {
    html: string;
    toc: TocItem[];
}

// Sanitizes the CMS HTML, gives every <h2> an id and builds the table of contents.
// Doing this on the HTML string (instead of editing the live DOM) means React
// never loses the ids when it re-renders.
export const prepareBlogContent = (rawHtml: string): PreparedContent => {
    // Removes scripts and inline event handlers, keeps normal article markup
    const cleanHtml = DOMPurify.sanitize(rawHtml);

    const doc = new DOMParser().parseFromString(cleanHtml, "text/html");
    const toc: TocItem[] = [];

    doc.querySelectorAll("h2").forEach((heading, index) => {
        const id = `section-${index}`;
        heading.id = id;
        toc.push({ id, text: heading.textContent ?? "" });
    });

    return { html: doc.body.innerHTML, toc };
};